import { DefaultRouteTabs } from '@/components/_common';
import BankSlipList from '@/components/Registry/Companies/BankSlips/BankSlipsList';
import useValidateRoutes from '@/hooks/useValidateRoutes';
import { PageProps } from '@/types/PageProps';

export default function CompanyBankSlipPage({ route }: PageProps) {
  const filterRoutes = route.parent.routes.filter(
    ({ key }) => key === 'bankSlips' || key === 'list',
  );
  route.parent.routes = filterRoutes;

  const routeValidate = useValidateRoutes({
    route: route.parent,
    keys: ['bankSlips'],
  });

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      route={routeValidate}
      baseKey={route.parent.key}
      basePath={route.parent.path}
    >
      <BankSlipList />
    </DefaultRouteTabs>
  );
}
